import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import {
  ArchiveBoxIcon,
  ArrowUturnLeftIcon,
  EnvelopeIcon,
} from "@heroicons/react/24/outline";
import { useTranslations } from "use-intl";
import { toast } from "sonner";
import { useMarkThreadAsUnread } from "@/app/Threads/hooks/useMarkThreadAsUnread";
import { useSetThreadClosed } from "@/app/Threads/hooks/useSetThreadClosed";
import { useThreadSelection } from "@/app/Threads/hooks/useThreadSelection";

export type ThreadActionTarget = {
  id: string;
  closed: boolean;
};

export function useThreadActions(): ActionsHook<ThreadActionTarget> {
  const t = useTranslations("thread.actions");
  const { mutateAsync: markAsUnread } = useMarkThreadAsUnread();
  const { mutateAsync: setClosed } = useSetThreadClosed();
  const { selectNextAfter } = useThreadSelection();

  return (model) => {
    const isClosed = model.closed;

    return [
      {
        label: t("title"),
        items: [
          {
            actions: [
              {
                isHiddenTopBar: true,
                label: t("markAsUnread"),
                Icon: EnvelopeIcon,
                handleAction: async () => {
                  try {
                    await markAsUnread({ thread_id: model.id });
                  } catch {
                    toast.error(t("markAsUnreadFailed"));
                  }
                },
              },
              {
                isHiddenTopBar: true,
                label: isClosed ? t("reopen") : t("close"),
                Icon: isClosed ? ArrowUturnLeftIcon : ArchiveBoxIcon,
                handleAction: async () => {
                  try {
                    selectNextAfter(model.id);
                    await setClosed({ id: model.id, closed: !isClosed });
                  } catch {
                    toast.error(t("setClosedFailed"));
                  }
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
